// import { CarouselOuter } from "../components/CarouselOuter";

export const CourseDj = () => {
    return (
        <>
            <h1 style={{color: "--color-white"}}>DJ COURSE</h1>
            {/* <CarouselOuter /> */}
        </>
    )
}

export default CourseDj;